import { useTranslation } from "react-i18next";
import type { EducationDetailDto } from "../../types/client-education-detail.types";
import { ChapterAccordion } from "./ContentSection/ChapterAccordion";
import styles from "./sections.module.scss";

/**
 * Kursiyer henüz başvurmadan / kayıtlı değilken görünen müfredat önizlemesi.
 * Başlıklar + objective listesi (ad, süre, tip) — InlinePlayer / completion yok.
 */
export function ContentPreviewSection(props: { education: EducationDetailDto }) {
  const { t } = useTranslation();
  const chapters = props.education.chapters ?? [];
  const hasContent = chapters.some((c) => (c.objectives ?? []).length > 0);
  if (!hasContent) return null;

  return (
    <section id="content-preview" className={styles.section}>
      <div className={styles.header}>
        <h2>{t("clientContentSection.title")}</h2>
      </div>
      <ChapterAccordion
        chapters={chapters}
        activeObjectiveId={null}
        onSelectObjective={() => undefined}
      />
    </section>
  );
}
